import React from "react";

const BarChartFillIcon = () => (
	<g>
		<path d='M3 12H7V21H3V12ZM17 8H21V21H17V8ZM10 2H14V21H10V2Z'></path>
	</g>
);

export default BarChartFillIcon;
